module.exports = __webpack_public_path__ + "static/assets/533a93f0d8b2d5ee66a7afc2a54cefb7.png";